import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Collapse.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/state";
const Collapse = (props) => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const [isOpen, setOpen] = useState(false);
  const { defaultStateOpen = false } = props;
  const { isMobile } = state;
  const refBody = useRef(null);
  const refInner = useRef(null);
  useEffect(() => {
    if (defaultStateOpen) {
      setOpen(true);
    }
  }, [defaultStateOpen]);
  useEffect(() => {
    const body = refBody.current;
    const inner = refInner.current;
    let rem = window.innerWidth * 1.176 / 100;
    if (isMobile) {
      rem = window.innerWidth * 4.267 / 100;
    }
    if (isOpen) {
      body.style.height = `${inner.offsetHeight / rem}rem`
    } else {
      body.style.height = `0rem`
    }
  }, [isMobile, isOpen]);
  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.header} onClick={() => setOpen(prev => !prev)}>
          <div className={isOpen ? `${styles.icon} ${styles.active}` : styles.icon}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16" cy="16" r="15" stroke="black" strokeWidth="2" />
              <rect x="15" y="8" width="2" height="16" fill="black" />
              <rect x="24" y="15" width="2" height="16" transform="rotate(90 24 15)" fill="black" />
            </svg>

          </div>
          <div className={styles.title}>{props.children[0]}</div>
        </div>
        <div className={styles.body} ref={refBody}>
          <div className={styles.inner} ref={refInner}>
            {props.children[1]}
          </div>
        </div>
      </div>
    </>
  );

}

export default Collapse;
